import { useMemo } from 'react'
import { useRouter } from 'next/router'

//* Component
import Text from 'components/common/Text'

//* Style
import CategoryFilterStyle from './style'

const CategoryFilter = ({ categories, queryCatKey, onChange, activeCountryId, className }) => {
    //! Router
    const router = useRouter()

    //! Active Category
    const activeCat = useMemo(() => router.query?.[queryCatKey], [router.query])

    //! Store filters
    const storeFilters = useMemo(() => {
        return categories.map((category) => (
            <div
                key={category.id}
                className='category-wrap-item'
            >
                <div
                    className={`category-item ${activeCat == category.id || activeCountryId === category.id ? 'active' : ''}`}
                    onClick={() => onChange(category.id)}
                >
                    <Text className={'p p-2 font-montserrat category-name textBlack-100'}>{category.name}</Text>
                </div>
            </div>
        ))
    }, [categories, activeCat, activeCountryId])

    return (
        <CategoryFilterStyle className={className || ''}>
            <div className='filters-wrap'>
                <div className='filters-inner-wrap'>
                    <div className='category-wrap-item'>
                        <div
                            className={`category-item ${!activeCat && !activeCountryId ? 'active' : ''}`}
                            onClick={() => onChange(null)}
                        >
                            <Text
                                className={'p p-2 font-montserrat category-name textBlack-100'}
                                text={'all'}
                            />
                        </div>
                    </div>

                    {storeFilters}
                </div>
            </div>
        </CategoryFilterStyle>
    )
}

export default CategoryFilter
